<template>
    <form-accordion
        name="buyer-information"
        section="Buyer Information"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <buyer-1
            :contact="contacts_buyer_1"
            :property="property"
            :read_only="read_only"
        />

        <buyer-2
            :deal="property.deal"
            :contact="contacts_buyer_2"
            :read_only="read_only"
        />

        <lender
            :contact="contacts_buyer_lender"
            :read_only="read_only"
        />

        <attorney
            :contact="contacts_buyer_attorney"
            :read_only="read_only"
        />

        <lawyers-sent-info
            :deal="property.deal"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import Buyer1 from './buyer-1.vue'
import Buyer2 from './buyer-2.vue'
import Lender from './lender.vue'
import Attorney from './attorney.vue'
import LawyersSentInfo from './lawyers-sent-info.vue'

export default {
    components: {
        Buyer1,
        Buyer2,
        Lender,
        Attorney,
        LawyersSentInfo,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        contacts_buyer_1: { default: () => ({}) },
        contacts_buyer_2: { default: () => ({}) },
        contacts_buyer_lender: { default: () => ({}) },
        contacts_buyer_attorney: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>

